module.exports = __webpack_public_path__ + "img/scan.4ecd1149.jpg";